import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';

const SwimlanesChangeboarding = {
	get(): boolean {
		return (
			// eslint-disable-next-line jira/ff/no-preconditioning
			expVal('board_harmonisation_m3_swimlanes', 'isEnabled', false) &&
			fg('board_harmonisation_m3_swimlanes_changeboarding')
		);
	},
};

export default SwimlanesChangeboarding;
